import Roles from '@/auth/roles';
import DocumentForm from './document-form';
import DocumentList from './document-list';
import DocumentShow from './document-show';

const roles = Roles.values;

export default [
  {
    name: 'documentList',
    path: 'document',
    component: DocumentList,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.documentViewer.id,
        roles.documentEditor.id,
        roles.clubManager.id,
      ]
    }
  },
  {
    name: 'documentNew',
    path: 'document/new',
    component: DocumentForm,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.entityEditor.id,
        roles.documentEditor.id
      ]
    }
  },
  {
    name: 'documentEdit',
    path: 'document/:id/edit',
    component: DocumentForm,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.entityEditor.id,
        roles.documentEditor.id
      ]
    }
  },

  {
    name: 'documentShow',
    path: 'document/:id',
    component: DocumentShow,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.documentViewer.id,
        roles.documentEditor.id,
        roles.clubManager.id,
      ]
    }
  }
];



// WEBPACK FOOTER //
// ./src/entities/document/document-routes.js